<ng-container *ngIf="regionState$ | async as state">
  <div
    class="collect mat-body-2"
    *ngIf="(activeChannel$ | async)?.defaultCollectionPoint as collectionPoint"
  >
    <div class="collect-message">Collect your order from {{ collectionPoint.name }}.</div>
    <button
      mat-stroked-button
      color="primary"
      (click)="regionService.collect(collectionPoint)"
      i18n="@@CallToAction.Collect"
    >
      COLLECT
    </button>
  </div>
</ng-container>
